import { complainceService, returnCargo } from "@/common/service/workflow/workflowService.js";
import { convertToLowerCase } from "@/common/utils/generic/commonHelper.js";
import workflow from "./workflowSearch";
import { constants } from "@/lib/CONSTANTS.js";
import { cleardqeData } from "@/common/service/apiaggregator/manifestAgreegatorService";

const state = {
  resultsCache: {},
  complainceId: null,
  parentRowIndex: null,
  compliancePort: null,
  loadPort: null,
  dateType: constants.pageSettings.exception.dateType[0].value,
  complainceRecords: [],
  updatecleardqedata: [],
  complainceRecordsLoader: false,
  complainceRecordsError: null,
  returnCargoLoader: false,
  checkDqeStatus: "dqeclose",
  returnCargoError: null,
  complainceRecordsPage: 0, //this is not needed for now but keeping it here
  complainceRecordItemsPerPage: 500, //as confirmed by backend team setting it as
  dateRangeFilter: workflow.state.dateRangeFilter
};

const mutations = {
  addToResultCache(state, contents) {
    for (let key of Object.keys(contents)) {
      state.resultsCache[key] = contents[key];
    }
  },
  resetResultCacheKeyData(state, data) {
    Object.assign(state.resultsCache, data);
  },
  setComplainceResult(state, result) {
    state.complainceRecords = result;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "hasError" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setDqeState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },

  setActiveComplainceId(state, id) {
    state.complainceId = id;
  },
  setParentRowIndex(state, index) {
    state.parentRowIndex = index;
  },
  setDteTypSelection(state, value) {
    state.dateType = value;
  },
  setDqeStatus(state, value) {
    state.checkDqeStatus = value;
  }
};

const actions = {
  async fetchComplainceRecords({ commit, state }, payload) {
    commit("setLoadingState", { type: "complainceRecords", value: true });
    commit("setDqeStatus", "dqeinital");

    commit("setComplainceResult", []);
    try {
      const { complianceId, loadPortSiteCode, compliancePortSiteCode, complianceType, exceptionTypes } = payload;
      // let rawData, data = state.resultsCache?.complainceRecords &&
      //  state.resultsCache.complainceRecords[`${complianceId}_${state.parentRowIndex}`];
      let rawData, data;
      // if (!data || data.length === 0) {
      let queryParams;
      if (convertToLowerCase(complianceType) === "advance manifest") {
        queryParams = {
          id: complianceId ? complianceId : "",
          page: state.complainceRecordsPage,
          compliancePortSiteCode,
          loadPortSiteCode,
          fromDate: state.dateRangeFilter?.start,
          toDate: state.dateRangeFilter?.end,
          dateType: state.dateType,
          size: state.complainceRecordItemsPerPage,
          exceptionTypes
        };
      } else {
        queryParams = {
          id: complianceId ? complianceId : "",
          page: state.complainceRecordsPage,
          compliancePortSiteCode,
          fromDate: state.dateRangeFilter?.start,
          toDate: state.dateRangeFilter?.end,
          dateType: state.dateType,
          size: state.complainceRecordItemsPerPage,
          exceptionTypes
        };
      }
      rawData = await complainceService(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "complainceRecords",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      let mapCompIdWithData = {};
      mapCompIdWithData[`${complianceId}_${state.parentRowIndex}`] = data;
      commit("setActiveComplainceId", complianceId);
      commit("addToResultCache", { complainceRecords: mapCompIdWithData }); //TODO: need to re-visit
      commit("setLoadingState", { type: "complainceRecords", value: false });
      // }
      commit("setComplainceResult", data);
      commit("setErrorState", { type: "complainceRecords", error: "" });
      // if (rootState.groupErrorFilters.checkedErrorList.length < 4) {
      // dispatch("filterComplainceData");
      // }
    } catch (error) {
      commit("addToResultCache", { complainceRecords: {} });
      commit("setErrorState", { type: "complainceRecords", error });
      commit("setLoadingState", { type: "complainceRecords", value: false });
    }
  },
  async returnCargo({ commit }, businessKey) {
    commit("setLoadingState", { type: "returnCargo", value: true });
    try {
      let rawData;
      rawData = await returnCargo(businessKey, true);
      if (rawData.status > 200 && rawData.status <= 499) {
        commit("setErrorState", {
          type: "returnCargo",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }
      commit("setErrorState", { type: "returnCargo", error: "" });
      commit("setLoadingState", { type: "returnCargo", value: false });
      return true;
    } catch (error) {
      commit("setErrorState", { type: "returnCargo", error });
      commit("setLoadingState", { type: "returnCargo", value: false });
    }
  },
  filterComplainceData({ commit, state, rootState }) {
    const cacheData = state.resultsCache?.complainceRecords
      ? JSON.parse(JSON.stringify(state.resultsCache?.complainceRecords))
      : null;
    const exceptionErrorFilters = rootState.groupErrorFilters.checkedErrorList;
    if (exceptionErrorFilters.length > 0 && cacheData) {
      let index = 0,
        filteredData = [],
        cacheComplainceData = cacheData[`${state.complainceId}_${state.parentRowIndex}`],
        length = cacheComplainceData.length;
      while (index < length) {
        let foundMatches = "";
        foundMatches = cacheComplainceData[index].workflowExceptions.filter(complaince =>
          exceptionErrorFilters.includes(complaince.exceptionType)
        );
        cacheComplainceData[index].workflowExceptions = foundMatches;
        if (cacheComplainceData[index].workflowExceptions.length > 0) filteredData.push(cacheComplainceData[index]);
        index++;
      }
      commit("setComplainceResult", filteredData);
    } else {
      commit("setComplainceResult", []);
      //commit("setComplainceResult", cacheData[state.complainceId]);
    }
  },

  async updateDQEData({ commit }, newParams) {
    commit("setDqeStatus", "dqeinital");
    commit("setDqeState", { type: "updatecleardqedata", value: true });
    try {
      let rawData = [];
      rawData = await cleardqeData(newParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "updatecleardqedata",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }
      commit("setDqeStatus", "dqeclose");
      commit("setErrorState", { type: "updatecleardqedata", error: "" });
      commit("setDqeState", { type: "updatecleardqedata", value: false });
    } catch (error) {
      commit("setDqeStatus", "dqeerr");
      commit("setErrorState", { type: "updatecleardqedata", error });
      commit("setDqeState", { type: "updatecleardqedata", value: false });
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
